import React from 'react';
import { Container, Dialog, Grid } from '@material-ui/core';
import { useStyles } from "./styles";
import LogoAnimation from "./logoAnimation";

export default function SimpleBackdrop(props) {
  const classes = useStyles();

  return (
	<Dialog open={props.open} id="dialogContainer">
		<Container direction="row" justify="center" alignItems="center" className={classes.colorComponente}>
			<Grid className={classes.rootContainer} item xs={12} > 
				<LogoAnimation/>
				<div className={classes.title}> {props.title ? props.title : 'Cargando ...'}</div>
			</Grid>
		</Container>      
		<div className={classes.lineaDegradadaBottom}></div>
	</Dialog>
  );
}